import { useCallback, useEffect, useState } from 'react';
import { SingleValue } from 'react-select';
import isEqual from 'lodash/isEqual';
import useFilterStore from './filterStore';
import { SelectedFilters } from '../../types/filters.type';
import DropdownEdit from '../form-inputs/inputDropdownActions';
import type { OptionType } from '../../types/forms.type';
import GetUserFilterTemplates from '../../services/adapters/userFilterTemplates';
import PostFilterTemplateValues from '../../services/adapters/filterTemplateValues';
import { useModal } from '../modalProvider';
import customIcons from '../../utils/icons';
import Button from '../buttons/baseButton';
import FilterTemplateForm from './filterTemplateForm';

export default function FilterTemplate() {
  const [filterTemplateOptions, setFilterTemplateOptions] = useState<OptionType[]>([]);

  const [selectedTemplate, setSelectedTemplate] = useState<OptionType>({ label: '', value: '' });
  const [selectedTemplatesFilters, setSelectedTemplatesFilters] = useState<SelectedFilters>({});
  const [formSubmitted, setFormSubmitted] = useState(0);
  const { openSimpleModal, closeModal } = useModal();
  const { selectedFilters, updateFilterStore } = useFilterStore();

  const hasSelectedFilters = Object.keys(selectedFilters).length > 0;

  const handleChange = (value: SingleValue<OptionType>) => {
    if (value) {
      setSelectedTemplate(value);
    } else {
      setSelectedTemplate({ label: '', value: '' });
    }
  };

  const showCreateTemplateModal = useCallback(() => {
    openSimpleModal({
      isOpen: true,
      title: 'Create Filter Template',
      children: <FilterTemplateForm onClose={() => { setFormSubmitted(formSubmitted + 1); closeModal(); }} />,
      onClose: closeModal,
    });
  }, [openSimpleModal, closeModal, formSubmitted]);

  useEffect(() => {
    const fetchTemplate = async (templateId: string) => {
      const snapshotAdapter = new PostFilterTemplateValues();
      const response = await snapshotAdapter.adaptResponse(templateId);
      if (response) {
        setSelectedTemplatesFilters(response);
        updateFilterStore(response);
      }
    };
    const fetchTemplates = async () => {
      const snapshotAdapter = new GetUserFilterTemplates();
      const response = await snapshotAdapter.adaptResponse();
      if (response) {
        setFilterTemplateOptions(response);
      }
    };
    if (selectedTemplate.value !== '') {
      fetchTemplate(selectedTemplate.value);
    }

    fetchTemplates();
  }, [selectedTemplate, showCreateTemplateModal, updateFilterStore, formSubmitted]);

  if (selectedTemplate.value !== ''
  && hasSelectedFilters) {
    const areEqual = isEqual(selectedFilters, selectedTemplatesFilters);
    if (!areEqual) {
      setSelectedTemplate({ label: '', value: '' });
    }
  }
  const filterTemplatesUnavailable = (
    <span
      className="px-2 text-center text-xs text-pipstatus-alert"
    >
      No filter templates created. please click the button below to create your first filter template
    </span>
  );

  return (
    <div className="border-t mt-2 bg-white">
      <div className="flex flex-col gap-4 p-4">
        {filterTemplateOptions.length > 0 ? (
          <>
            <DropdownEdit
              id="select-template"
              label="Select Template"
              selected={selectedTemplate}
              placement="top"
              options={filterTemplateOptions}
              onChange={handleChange}
            />
            <p className="text-frame">
              OR
            </p>
          </>
        ) : filterTemplatesUnavailable}

        <Button
          id="open-create-template-modal"
          className="button-default"
          onClick={showCreateTemplateModal}
          icon={customIcons.fileUp}
          label="Create template with selected filters"
        />
      </div>
    </div>
  );
}
